import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import Form from './Form';

const FormPicker = (props) => {
  return pickFunction(props.resource, {
    [fr.relationships.default.name]: () => {
      return (
        <Form {...props} />
      );
    },
  });
};

export default FormPicker;
